import { Form, Input } from "antd";
import React from "react";

const ClientServerToken: React.FC = () => {
  return (
    <Form.Item name="organizationServerToken" label="Client Server Token">
      <Input />
    </Form.Item>
  );
};

export default ClientServerToken;
